export default async function importSchema(schemaName: string | undefined) {
  try {
    const schema = (await import(`@core/schemas/${schemaName}.json`)).default;
    return schema;
  } catch (err) {
    return null;
  }
}
